/**
 * Hora local de una captura a partir de las coordenadas.
 * Península y Baleares: Europe/Madrid. Canarias: Atlantic/Canary.
 * Portugal continental (caja aproximada): Europe/Lisbon. El resto, huso fijo sin horario de verano.
 */

export function fishingTimeZone(lat: number | null, lng: number | null): string | null {
    if (lat == null || lng == null || !Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    if (lat >= 27 && lat <= 29.6 && lng >= -18.5 && lng <= -13) return 'Atlantic/Canary';
    if (lat >= 36.8 && lat < 42 && lng >= -9.6 && lng <= -6.2) return 'Europe/Lisbon';
    if (lat >= 35 && lat <= 44.5 && lng >= -10 && lng <= 4.5) return 'Europe/Madrid';
    const offset = Math.round(lng / 15);
    if (offset === 0) return 'Etc/GMT';
    const sign = offset > 0 ? '-' : '+';
    return `Etc/GMT${sign}${Math.abs(offset)}`;
}

function clock(date: Date, timeZone: string): string {
    return new Intl.DateTimeFormat('en-GB', {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).format(date);
}

export function formatCaptureClock(
    iso: string | null,
    lat: number | null,
    lng: number | null,
): { horaUtc: string | null; horaLocal: string | null; zonaHoraria: string | null } {
    if (!iso) return { horaUtc: null, horaLocal: null, zonaHoraria: null };
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return { horaUtc: null, horaLocal: null, zonaHoraria: null };
    const horaUtc = clock(date, 'UTC');
    const zonaHoraria = fishingTimeZone(lat, lng);
    if (!zonaHoraria) return { horaUtc, horaLocal: null, zonaHoraria: null };
    return { horaUtc, horaLocal: clock(date, zonaHoraria), zonaHoraria };
}

/** Iluminación guardada como fracción 0–1 o como porcentaje 0–100 → entero 0–100. */
export function illuminationPercent(value: number | null): number | null {
    if (value == null || !Number.isFinite(value)) return null;
    if (value > 1) return Math.min(100, Math.round(value));
    if (value < 1) return Math.round(value * 100);
    return 1;
}
